<template>
  <div class="auth-wrapper auth-v1 px-2">
    <AnimatedAiBackground />
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo d-block">
          <div
            style="width: 300px"
            class="d-flex align-items-center justify-content-center mb-1 m-auto"
          >
            <img style="width: 100%" src="/sofIAweb.webp" alt="SofIA" />
          </div>
          <h4 class="brand-text text-center">
            {{ $t("pages.login.salesFuture") }}, <br />
            {{ $t("pages.login.unlock") }}
          </h4>
        </b-link>
        <validation-observer ref="loginForm" #default="{ invalid }">
          <b-form class="auth-login-form mt-2" @submit.prevent="login">
            <b-form-group label-for="email" :label="$t('pages.login.email')">
              <validation-provider
                #default="{ errors }"
                :name="$t('pages.login.email')"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="userEmail"
                  name="login-email"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('pages.login.email')"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">{{ $t("pages.login.password") }}</label>
              </div>
              <validation-provider
                #default="{ errors }"
                :name="$t('pages.login.password')"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                    :placeholder="$t('pages.login.password')"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-button variant="primary" type="submit" block :disabled="invalid">
              {{ $t("pages.login.login") }}
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { login } from "@core/api/request";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import { showLoading, stopLoading } from "@core/utils/utils";
import { setCookie } from "@/auth/CookiesManager";
import AnimatedAiBackground from "../../landing/AnimatedAiBackground.vue";
import { getProfile } from "@/@core/api/request/profiles";
import sessionBuilder from "@/security/context/sessionContext";

const profile = {
  guid: null,
  name: null,
  permissions: [],
};

export default {
  components: {
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BLink,
    VuexyLogo,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    AnimatedAiBackground,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: "",
      password: "",
      status: "",
      required,
      email,
      profile: Object.assign(profile),
    };
  },

  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  watch: {
    "$i18n.locale"(locale) {
      localize(locale);
    },
  },
  created() {
    localize(this.$i18n.locale);
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          this.$store.commit("appConfig/SET_RESET_SESSION_CONTEXT");
          this.$store.commit("appConfig/CLEAR_ACTIVE_COMPANY");

          showLoading();
          const user = {
            email: this.userEmail,
            password: this.password,
          };
          login(user)
            .then(async (response) => {
              const userJwt = this.parseJwt(response.data);
              if (response.err) {
                const message = _.get(response, "data.message");
                this.$refs.loginForm.setErrors(
                  message || "Error en autenticación",
                );
                this.alertToast(
                  "danger",
                  "Alerta error",
                  message || "Error en autenticación",
                  "AlertTriangleIcon",
                );
                return;
              }
              if (!response?.token) {
                this.alertToast(
                  "danger",
                  "Alerta error",
                  "No existe token",
                  "AlertTriangleIcon",
                );
                return;
              }

              this.$store.commit("appConfig/SET_TOKEN", response.token);
              setCookie("token", response.token, 1);

              await this.getProfileUser(
                userJwt?.guidProfile,
                userJwt,
                response.token,
              );

              const userData = {};
              userData.role = userJwt.role = userJwt.nameProfile
                .toUpperCase()
                .replace(/\s/g, "");
              userData.Name = userJwt.Name;
              userData.nameProfile = userJwt.nameProfile;

              setCookie("role", userData.role, 1);
              setCookie("user", JSON.stringify(userData), 1);
              setCookie("logout", false, 1);

              this.$store.commit("appConfig/UPDATE_USER", userJwt);
              this.$store.commit("appConfig/SET_ROLE", userData.role);

              this.$ability.update([{ action: "manage", subject: "all" }]);

              const homeRoute = getHomeRouteForLoggedInUser(userData.role);
              this.$router.replace(homeRoute).then(() => {});
            })
            .catch((error) => {
              console.log("error", error.message);
              this.alertToast(
                "danger",
                "Error",
                error.message,
                "AlertTriangleIcon",
              );
            })
            .finally(() => {
              stopLoading();
            });
        }
      });
    },

    getProfileUser(guidProfile, userJwt, token) {
      showLoading();
      return getProfile(guidProfile)
        .then((resp) => {
          const response = _.get(resp, "data");
          this.profile = Object.assign(this.profile, {
            guid: response.guid,
            name: response.name,
            permissions: response.permissions,
          });
          this.$store.commit(
            "appConfig/SET_MENU_PERMISSIONS",
            response.permissions || [],
          );
          this.$store.commit(
            "appConfig/SET_ID_CAT_TYPE_PROFILE",
            response.idCatType || 314,
          );

          const sessionContext = sessionBuilder.build({
            token: token || null,
            refreshToken: null,

            idUser: userJwt.guid || null,
            idCompany: null,
            idProfile: userJwt.guidProfile || null,

            idCatType: response.idCatType || 314,
            photo: userJwt?.photo || null,
            profileName: userJwt.nameProfile || null,
            companyType: userJwt.companyType || null,
            menuPermissions: response.permissions || [],
            features: userJwt.features || [],
          });

          this.$store.commit("appConfig/SET_SESSION_CONTEXT", sessionContext);
        })
        .catch((error) => {
          console.log("error", error);

          this.alertToast(
            "danger",
            "Error",
            error.message,
            "AlertTriangleIcon",
          );
        })
        .finally(() => {
          stopLoading();
        });
    },

    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(""),
      );
      return JSON.parse(jsonPayload);
    },

    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
<style lang="scss" scoped>
.sofia-logo-4 {
  position: absolute;
  left: 70%;
  width: 400px;
  top: 12rem;
}

@media (max-width: 768px) {
  .sofia-logo-4 {
    display: none;
  }
}
@media (max-width: 480px) {
  .sofia-logo-4 {
    display: none;
  }
}
</style>
